// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"checkoutForm__gradient-bg5__pQR8Q","checkoutForm":"checkoutForm__checkoutForm__FM4eh"};